import { WIDGET_SHADOW_ROOT_ENABLED_DATA_ATTR } from "@/constants";
import { WISHLIST_WIDGET_NAMES } from "@/constants/widget-names";
import { SharedWishlistPageWidgetDefinition } from "@apps/wishlist/definitions";
import AnalyticsEventsCollectorInterface from "@modules/analytics_events_collector/AnalyticsEventsCollector/AnalyticsEventsCollectorInterface";
import { AnalyticsEventsFactory } from "@modules/analytics_events_collector/AnalyticsEventsCollector/AnalyticsEventsFactory";
import { DynamicImportManager } from "@modules/dynamic_import/DynamicImportManager";
import WidgetInjectedSdkEvent from "@modules/sdk/common_sdk/events/WidgetInjectedSdkEvent";
import { dispatchSdkEvent } from "@modules/sdk/helpers";
import MutationObserverInjector from "@ui-utils/Injector/MutationObserverInjector";
import { parseOptionalBooleanDataAttr } from "@ui-utils/Injector/utils";

import { LoggerInterface } from "@interfaces/LoggerInterface";

class SharedWishlistPageWidgetInjector {
    constructor(
        private readonly placeholderSelector: string,
        private readonly logger: LoggerInterface,
        private readonly eventsCollector: AnalyticsEventsCollectorInterface,
        private readonly analyticsEventsFactory: AnalyticsEventsFactory,
        private readonly dynamicImportManager: DynamicImportManager,
        private readonly moi: MutationObserverInjector
    ) {}

    start() {
        this.logger.debug(`${SharedWishlistPageWidgetInjector.name}.start`, {
            placeholderSelector: this.placeholderSelector,
        });

        const targets$ = this.moi.register({
            targetSelector: this.placeholderSelector,
        });

        targets$.subscribe((placeholder) => {
            this.logger.debug(
                `${SharedWishlistPageWidgetInjector.name} found placeholder`,
                placeholder
            );

            void (async () => {
                const SharedWishlistPageWidget =
                    await this.dynamicImportManager.importDefault(
                        SharedWishlistPageWidgetDefinition,
                        true
                    );

                const widget = new SharedWishlistPageWidget(
                    {
                        target: placeholder,
                        isWidgetShadowRootEnabled: parseOptionalBooleanDataAttr(
                            placeholder,
                            WIDGET_SHADOW_ROOT_ENABLED_DATA_ATTR
                        ),
                    },
                    this.logger,
                    this.dynamicImportManager
                );

                await widget.init();

                this.eventsCollector.pushEvent(
                    this.analyticsEventsFactory.createWidgetInjected(
                        WISHLIST_WIDGET_NAMES.SHARED_WISHLIST_PAGE_WIDGET
                    )
                );

                dispatchSdkEvent(
                    new WidgetInjectedSdkEvent(
                        WISHLIST_WIDGET_NAMES.SHARED_WISHLIST_PAGE_WIDGET
                    )
                );
            })();
        });
    }
}

export default SharedWishlistPageWidgetInjector;
